export default __webpack_public_path__ + "static/media/enfance.64462aa1.png";